import { uppercase, capitalize } from './format'

const createTitle = (init, strings) => {
	try {
		switch (init.category) {
			case 'sport':
				return `${strings[init.type]} ${strings[`in${capitalize(init.destination.name)}`]}`

			case 'sportEvent':
				return `${strings[init.type]} ${strings.with} ${init.host} ${strings[`in${capitalize(init.destination.name)}`]}`

			default:
				return ''
		}
	} catch (error) {
		return ''
	}
}

export { createTitle }